<template>
  <div class="page page-support">
    <nav-bar />
    <div class="page-wrapper">
      <div class="support">
        <div class="support__main">
          <h1 class="support__title">Единый Контактный Центр Amway</h1>
          <div class="support__form">
            <div v-if="!$store.state.isKZ" class="support__text">
              <div class="support__text__title">
                Тел. для Москвы и Московской области:
              </div>
              <a href="tel:+74959814000" class="support__text__phone">
                +7 (495) 981-4000
              </a>
              <div class="support__text__title">
                Многоканальная справочная служба
              </div>
              <a href="tel:88001009000" class="support__text__phone">
                8-800-100-9000
              </a>
              <div class="support__text__title">
                Email
              </div>
              <a href="mailto:inforu@amway.com" class="support__text__email">
                inforu@amway.com
              </a>
              <a href="https://www.amway.ru/contact-us" class="support__send">
                Подробнее
              </a>
            </div>
            <div v-else class="support__text">
              <div class="support__text__title">
                Телефон:
              </div>
              <a href="tel:88000805508" class="support__text__phone">
                8-800-080-55-08
              </a>
              <div class="support__text__title">
                Email
              </div>
              <a href="mailto:infokz@amway.com" class="support__text__email">
                infokz@amway.com
              </a>
              <a href="https://www.amway.kz/contact-us" class="support__send">
                Подробнее
              </a>
            </div>
          </div>
        </div>
        <div class="support__buttons">
          <button class="support__back" @click="$router.push('/')">
            <svg-icon type="back" />
            Назад
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CInput from "../components/forms/CInput";
import CSelect from "../components/forms/CSelect";
import CInputFile from "../components/forms/CInputFile";

export default {
  name: "Support",
  components: { CSelect, CInput, CInputFile },
  data() {
    let aboN = null;
    if (this.$store.state.user) {
      aboN = this.$store.state.user.abo_number;
    }
    return {
      show_tooltip: true,
      isMobile: window.innerWidth < 768,
      countryOptions: [
        {
          label: "Россия",
          value: "RU"
        },
        {
          label: "Казахстан",
          value: "KZ"
        },
        {
          label: "Другая",
          value: "other"
        }
      ],
      supportForm: {
        name: {
          valid: false,
          required: true,
          value: ""
        },
        abo_number: {
          valid: !!aboN,
          required: true,
          value: aboN
        },
        message: {
          valid: false,
          required: true,
          value: ""
        },
        email: {
          valid: false,
          required: true,
          value: ""
        },
        phone: {
          valid: false,
          required: false,
          value: ""
        },
        file: {
          valid: false,
          required: false,
          value: null
        },
        country: {
          valid: false,
          required: true,
          value: ""
        }
      }
    };
  },
  methods: {
    showTooltip() {
      this.show_tooltip = false;
    },
    processFile(e) {
      let file = e.target.files[0];
      if (file) {
        this.supportForm.file.valid = true;
        this.supportForm.file.value = file;
      }
    },
    sendMessage() {
      let data = new FormData();
      let hasError = false;
      for (let key in this.supportForm) {
        if (this.supportForm.hasOwnProperty(key)) {
          let object = this.supportForm[key];
          if (object.required && !object.valid) {
            hasError = true;
          }
          data.append(key, object.value);
        }
      }
      if (hasError) {
        return;
      }
      fetch(`${process.env.VUE_APP_API_ROOT}/api/moderation/call`, {
        method: "POST",
        credentials: "include",
        headers: {},
        body: data
      })
        .then(r => r.json())
        .then(response => {
          if (response.status === "ok") {
            this.$eventBus.$emit("serverSyncSuccess", {
              msg: "Сообщение успешно отправлено"
            });
            this.$router.push("/");
          } else
            this.$eventBus.$emit("showError", {
              msg: "Ошибка при отправлении сообщения"
            });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars.scss";

.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }

  &-wrapper {
    max-width: 100%;
    display: flex;
    justify-content: center;
    @media #{$tablet} {
      margin: 0;
      padding: 0;
    }
  }
}

.support {
  width: 100%;
  max-width: 1200px;
  background: #f4f4f4;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @media #{$tablet} {
    min-height: calc(100vh - 118px);
    border-radius: 0;
    justify-content: space-between;
  }
  @media #{$mobile} {
    background: #ffffff;
  }

  &__text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &__title {
      font-size: 16px;
      line-height: 140%;
      color: #212121;
      margin-bottom: 5px;
    }
    &__phone {
      font-weight: 600;
      font-size: 24px;
      line-height: 140%;
      color: #303333;
      margin-bottom: 30px;
      text-decoration: none;
    }
    &__email {
      font-weight: 600;
      font-size: 24px;
      line-height: 140%;
      color: #3a5eec;
      text-decoration: none;
      margin-bottom: 30px;
    }
  }

  * {
    font-family: "Inter", sans-serif;
  }

  &__title {
    font-size: 48px;
    font-weight: bold;
    text-align: left;
    margin: 0 0 60px;
    padding: 0;
    @media #{$mobile} {
      font-size: 34px;
      margin: 0 0 30px;
    }
  }

  &__main {
    padding: 60px 70px;
    @media #{$mobile} {
      padding: 30px 15px;
    }
  }

  &__form {
    display: flex;
    @media #{$mobile} {
      flex-direction: column;
    }

    &__column {
      display: flex;
      flex-direction: column;
      flex-basis: 290px;
      @media #{$mobile} {
        flex-basis: 100%;
      }

      &:not(:last-child) {
        margin-right: 30px;
        @media #{$mobile} {
          margin-right: 0;
        }
      }
    }
  }

  &__input {
    display: flex;
    flex-direction: column;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    input,
    textarea {
      border: 1px solid #cccccc;
      outline: none;
      border-radius: 5px;
      padding: 10px 15px;
      font-size: 16px;
      background: transparent;
      resize: none;

      &:focus {
        border-color: #3479cc;
      }
    }

    &.valid input,
    &.valid textarea {
      border-color: #3479cc;
    }

    &.invalid input,
    &.invalid textarea {
      border-color: #3479cc;
    }

    textarea {
      height: 90px;
    }

    &__name {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
    }
  }

  &__file_wrapper {
    background: #ffffff;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    @media #{$mobile} {
      background: #f2f2f2;
    }

    & *:first-child {
      margin-right: 20px;
    }

    span {
      font-size: 15px;
      max-width: 180px;
    }

    input {
      display: none;
    }
  }

  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__back {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
    @media #{$mobile} {
      margin-bottom: 30px;
    }

    span {
      margin-right: 10px;
    }
  }

  &__send {
    border-radius: 5px;
    border: none;
    background: #3a5eec;
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    padding: 15px 40px;
    @media #{$mobile} {
      margin-bottom: 30px;
      align-self: center;
    }
  }

  &__legend {
    color: #cccccc;
    font-size: 16px;
    line-height: 140%;
    padding-top: 8px;
    @media #{$mobile} {
      padding-top: 0;
    }
  }

  .input__file {
    @media #{$tablet} {
      margin-bottom: 20px;
    }
  }
}
</style>
